export default __webpack_public_path__ + "static/media/register_an_org.02102f25.svg";